import { toast } from 'react-toastify';
import { deleteIncomeDocumentApi, deleteWorkDocumentApi } from '../../apis/borrower';
import { handleApiError } from '../../helpers';
import useToggle from '../useToggle';

export const useDeleteDocuments = (fetchBorrowerProfile: () => Promise<void>) => {
  const { show: showWorkDocument, toggle: toggleShowWorkDocument } = useToggle(true);
  const { show: showIncomeDocument, toggle: toggleShowIncomeDocument } = useToggle(true);

  const deleteWorkDocument = async () => {
    toggleShowWorkDocument();
    try {
      await deleteWorkDocumentApi();
      await fetchBorrowerProfile();
    } catch (error) {
      toast.error(handleApiError(error));
      toggleShowWorkDocument();
    }
  };

  const deleteIncomeDocument = async () => {
    toggleShowIncomeDocument();
    try {
      await deleteIncomeDocumentApi();
      await fetchBorrowerProfile();
    } catch (error) {
      toast.error(handleApiError(error));
      toggleShowIncomeDocument();
    }
  };

  return {
    showWorkDocument,
    showIncomeDocument,
    deleteWorkDocument,
    deleteIncomeDocument,
  };
};
